<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "auth-wrapper auth-v2" },
    [
      _c(
        "b-row",
        { staticClass: "auth-inner m-0" },
        [
          _c(
            "b-col",
            {
              staticClass:
                "d-flex align-items-center justify-content-center auth-bg p-3",
              attrs: { lg: "5" },
            },
            [
              _c("div", [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-between align-items-center li-marker mb-3",
                  },
                  [
                    _c(
                      "h2",
                      { staticClass: "brand-text text-primary" },
                      [_c("Logo", { staticClass: "pike-brand-logo" })],
                      1
                    ),
                    _c("locale"),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "min-w-i" },
                  [
                    _c(
                      "b-card-title",
                      {
                        staticClass: "font-weight-bold mb-1",
                        attrs: { "title-tag": "h2" },
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$t("register.createAccount")) + " "
                        ),
                      ]
                    ),
                    _c("validation-observer", {
                      ref: "registerForm",
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (ref) {
                            var invalid = ref.invalid
                            return [
                              _c(
                                "b-form",
                                {
                                  staticClass: "auth-register-form mt-2",
                                  on: {
                                    submit: function ($event) {
                                      $event.preventDefault()
                                      return _vm.register($event)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: _vm.$t("register.Country"),
                                        "label-for": "country ",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "label",
                                            fn: function () {
                                              return [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("register.Country")
                                                    ) + " "
                                                  ),
                                                  _c(
                                                    "span",
                                                    { staticClass: "red-star" },
                                                    [_vm._v("*")]
                                                  ),
                                                ]),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _c("validation-provider", {
                                        attrs: {
                                          name: _vm.$t("register.country"),
                                          id: "country",
                                          rules: "required",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (ref) {
                                                var errors = ref.errors
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      attrs: {
                                                        state:
                                                          errors.length > 0
                                                            ? false
                                                            : null,
                                                      },
                                                    },
                                                    [
                                                      _c("CountrySelect", {
                                                        attrs: {
                                                          name: _vm.$t(
                                                            "register.country"
                                                          ),
                                                          placeholder: _vm.$t(
                                                            "register.countryPlaceholder"
                                                          ),
                                                          autocomplete: "off",
                                                          clearable: false,
                                                          reduce: "id",
                                                        },
                                                        model: {
                                                          value: _vm.country,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.country = $$v
                                                          },
                                                          expression: "country",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _c("Errors", {
                                                    attrs: { error: errors[0] },
                                                  }),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: _vm.$t("register.email"),
                                        "label-for": "register-email",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "label",
                                            fn: function () {
                                              return [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("register.email")
                                                    ) + " "
                                                  ),
                                                  _c(
                                                    "span",
                                                    { staticClass: "red-star" },
                                                    [_vm._v("*")]
                                                  ),
                                                ]),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _c("validation-provider", {
                                        attrs: {
                                          name: _vm.$t("register.email"),
                                          id: "email",
                                          rules: "required|email",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (ref) {
                                                var errors = ref.errors
                                                return [
                                                  _c("b-form-input", {
                                                    attrs: {
                                                      id: "register-email",
                                                      name: _vm.$t(
                                                        "register.email"
                                                      ),
                                                      state:
                                                        errors.length > 0
                                                          ? false
                                                          : null,
                                                      placeholder: _vm.$t(
                                                        "login.emailPlaceholder"
                                                      ),
                                                      autocomplete: "off",
                                                    },
                                                    model: {
                                                      value: _vm.userEmail,
                                                      callback: function ($$v) {
                                                        _vm.userEmail = $$v
                                                      },
                                                      expression: "userEmail",
                                                    },
                                                  }),
                                                  _c("Errors", {
                                                    attrs: { error: errors[0] },
                                                  }),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-for": "register-password",
                                        label: _vm.$t("register.Password"),
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "label",
                                            fn: function () {
                                              return [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "register.Password"
                                                      )
                                                    ) + " "
                                                  ),
                                                  _c(
                                                    "span",
                                                    { staticClass: "red-star" },
                                                    [_vm._v("*")]
                                                  ),
                                                ]),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _c("validation-provider", {
                                        attrs: {
                                          name: "password",
                                          id: "password",
                                          rules: "required|password",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (ref) {
                                                var errors = ref.errors
                                                return [
                                                  _c(
                                                    "b-input-group",
                                                    {
                                                      staticClass:
                                                        "input-group-merge",
                                                      class:
                                                        errors.length > 0
                                                          ? "is-invalid"
                                                          : null,
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        staticClass:
                                                          "form-control-merge",
                                                        attrs: {
                                                          id: "register-password",
                                                          type: _vm.passwordFieldType,
                                                          state:
                                                            errors.length > 0
                                                              ? false
                                                              : null,
                                                          name: _vm.$t(
                                                            "register.Password"
                                                          ),
                                                          placeholder: _vm.$t(
                                                            "login.passwordPlaceholder"
                                                          ),
                                                          autocomplete: "off",
                                                        },
                                                        model: {
                                                          value: _vm.password,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.password = $$v
                                                          },
                                                          expression:
                                                            "password",
                                                        },
                                                      }),
                                                      _c(
                                                        "b-input-group-append",
                                                        {
                                                          attrs: {
                                                            "is-text": "",
                                                          },
                                                        },
                                                        [
                                                          _c("feather-icon", {
                                                            staticClass:
                                                              "cursor-pointer",
                                                            attrs: {
                                                              icon: _vm.passwordToggleIcon,
                                                            },
                                                            on: {
                                                              click:
                                                                _vm.togglePassword,
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c("Errors", {
                                                    attrs: { error: errors[0] },
                                                  }),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-for": "register-password",
                                        label: _vm.$t(
                                          "register.confirmPassword"
                                        ),
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "label",
                                            fn: function () {
                                              return [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "register.confirmPassword"
                                                      )
                                                    ) + " "
                                                  ),
                                                  _c(
                                                    "span",
                                                    { staticClass: "red-star" },
                                                    [_vm._v("*")]
                                                  ),
                                                ]),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _c("validation-provider", {
                                        attrs: {
                                          name: _vm.$t(
                                            "register.confirmPassword"
                                          ),
                                          id: "ConfirmPassword",
                                          rules: "required|confirmed:password",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (ref) {
                                                var errors = ref.errors
                                                return [
                                                  _c(
                                                    "b-input-group",
                                                    {
                                                      staticClass:
                                                        "input-group-merge",
                                                      class:
                                                        errors.length > 0
                                                          ? "is-invalid"
                                                          : null,
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        staticClass:
                                                          "form-control-merge",
                                                        attrs: {
                                                          id: "register-password",
                                                          type: _vm.confirmPasswordFieldType,
                                                          state:
                                                            errors.length > 0
                                                              ? false
                                                              : null,
                                                          name: "register-password",
                                                          placeholder: _vm.$t(
                                                            "login.passwordPlaceholderConf"
                                                          ),
                                                          autocomplete: "off",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.confirmPassword,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.confirmPassword =
                                                              $$v
                                                          },
                                                          expression:
                                                            "confirmPassword",
                                                        },
                                                      }),
                                                      _c(
                                                        "b-input-group-append",
                                                        {
                                                          attrs: {
                                                            "is-text": "",
                                                          },
                                                        },
                                                        [
                                                          _c("feather-icon", {
                                                            staticClass:
                                                              "cursor-pointer",
                                                            attrs: {
                                                              icon: _vm.confirmPasswordToggleIcon,
                                                            },
                                                            on: {
                                                              click:
                                                                _vm.togglePasswordConfirm,
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c("Errors", {
                                                    attrs: { error: errors[0] },
                                                  }),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("ReCaptcha", {
                                    attrs: {
                                      verifyCaptcha: _vm.verifyCaptcha,
                                      captchaErr: _vm.captchaErr,
                                    },
                                  }),
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "mt-1",
                                      attrs: {
                                        variant: "primary",
                                        block: "",
                                        type: "submit",
                                        disabled:
                                          invalid ||
                                          !_vm.status ||
                                          _vm.isLoading,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("register.register")) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c(
                      "p",
                      { staticClass: "text-center mt-2" },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("register.alreadyAccount"))),
                        ]),
                        _c(
                          "b-link",
                          {
                            attrs: {
                              to: {
                                name: "auth-login",
                                params: { lang: this.lang || undefined },
                              },
                            },
                          },
                          [
                            _c("span", [
                              _vm._v(
                                " " + _vm._s(_vm.$t("register.signInInstead"))
                              ),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
          _c(
            "b-col",
            {
              staticClass: "d-none d-lg-flex align-items-center auth-bg",
              attrs: { lg: "7" },
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "w-100 d-lg-flex align-items-center justify-content-center",
                },
                [_c("SideImg2")],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/views/auth/Register.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import * as veevalidate from 'vee-validate';
import core_layouts_components_Logo_vue from '@core/layouts/components/Logo.vue';
import assets_images_pages_login_v2_svg from '@/assets/images/pages/login-v2.svg';
import * as bootstrapvue from 'bootstrap-vue';
import validations from '@validations';
import core_mixins_ui_forms from '@core/mixins/ui/forms';
import store_index from '@/store/index';
import auth_jwt_useJwt from '@/auth/jwt/useJwt';
import * as vuerecaptcha from 'vue-recaptcha';
import layouts_components_CountrySelect_vue from '@/layouts/components/CountrySelect.vue';
import core_components_toastification_ToastificationContent_vue from '@core/components/toastification/ToastificationContent.vue';
import libs_api_api from '@/libs/api/api';
import views_auth_ReCaptcha_vue from '@/views/auth/ReCaptcha.vue';
import layouts_components_Locale_vue from '@/layouts/components/Locale.vue';
import EventBus from '@/EventBus';
import layouts_components_Errors_vue from '@/layouts/components/Errors.vue';
import assets_rashi_coin_logo_svg from '@/assets/rashi-coin/logo.svg';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable global-require */

















export default ({
  render,
  staticRenderFns,
  components: {
    VuexyLogo: core_layouts_components_Logo_vue,
    BRow: bootstrapvue["BRow"],
    BImg: bootstrapvue["BImg"],
    BCol: bootstrapvue["BCol"],
    BLink: bootstrapvue["BLink"],
    BButton: bootstrapvue["BButton"],
    BForm: bootstrapvue["BForm"],
    BCardText: bootstrapvue["BCardText"],
    BCardTitle: bootstrapvue["BCardTitle"],
    BFormCheckbox: bootstrapvue["BFormCheckbox"],
    BFormGroup: bootstrapvue["BFormGroup"],
    BFormInput: bootstrapvue["BFormInput"],
    BInputGroup: bootstrapvue["BInputGroup"],
    BInputGroupAppend: bootstrapvue["BInputGroupAppend"],
    VueRecaptcha: vuerecaptcha["VueRecaptcha"],
    // validations
    ValidationProvider: veevalidate["ValidationProvider"],
    ValidationObserver: veevalidate["ValidationObserver"],
    SideImg2: assets_images_pages_login_v2_svg,
    CountrySelect: layouts_components_CountrySelect_vue,
    ReCaptcha: views_auth_ReCaptcha_vue,
    Locale: layouts_components_Locale_vue,
    Errors: layouts_components_Errors_vue,
    Logo: assets_rashi_coin_logo_svg
  },
  mixins: [core_mixins_ui_forms["togglePasswordVisibility"]],
  data() {
    return {
      country: "IN",
      userEmail: "",
      password: "",
      confirmPassword: "",
      sideImg: require("@/assets/images/pages/login-v2.svg"),
      status: false,
      captchaErr: "",
      captchaResponse: "",
      lang: this.$route.params.lang,
      isLoading: false,
      passwordFieldType: "password",
      confirmPasswordFieldType: "password",
      required: validations["required"],
      email: validations["email"]
    };
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    confirmPasswordToggleIcon() {
      return this.confirmPasswordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    imgUrl() {
      if (store_index.state.appConfig.layout.skin === "dark") {
        this.sideImg = require("@/assets/images/pages/login-v2-dark.svg");
        return this.sideImg;
      }
      return this.sideImg;
    }
  },
  methods: {
    verifyCaptcha(status, captchaResponse) {
      this.status = status;
      this.captchaResponse = captchaResponse;
    },
    togglePassword() {
      this.passwordFieldType = this.passwordFieldType === "password" ? "text" : "password";
    },
    togglePasswordConfirm() {
      this.confirmPasswordFieldType = this.confirmPasswordFieldType === "password" ? "text" : "password";
    },
    register() {
      const me = this;
      this.$refs.registerForm.validate().then(success => {
        if (success) {
          if (me.status) {
            me.captchaErr = "";
            me.signup();
          } else {
            me.captchaErr = "Captcha check required";
          }
        }
      });
    },
    async signup() {
      try {
        this.isLoading = true;
        const res = await new libs_api_api().api({
          method: "post",
          url: "auth/signup"
        }, {
          countryCode: this.country,
          email: this.userEmail,
          password: this.password,
          captchaResponse: this.captchaResponse
        }, {
          isLoading: true
        });
        EventBus.$emit("reset_captcha");
        if (res && res.message) {
          this.$router.push({
            name: "verify-email",
            params: {
              lang: this.lang || undefined,
              email: this.userEmail
            }
          });
        } else if (res && res.error && res.error.message) {
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: res.error.message,
              icon: "EditIcon",
              variant: "danger"
            }
          });
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
      this.isLoading = false;
    }
  }
});
/* eslint-disable global-require */

//# sourceURL=webpack:///./src/views/auth/Register.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

<style>
.auth-wrapper {
  display: flex;
  flex-basis: 100%;
  min-height: 100vh;
  min-height: calc(var(--vh, 1vh) * 100);
  width: 100%;
}
.auth-wrapper .auth-inner {
  width: 100%;
  position: relative;
}
.auth-wrapper.auth-v1 {
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.auth-wrapper.auth-v1 .auth-inner:before {
  width: 244px;
  height: 243px;
  content: " ";
  position: absolute;
  top: -54px;
}
[dir] .auth-wrapper.auth-v1 .auth-inner:before {
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPQAAADzCAMAAACG9Mt0AAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAA9KADAAQAAAABAAAA8wAAAADhQHfUAAAAyVBMVEUAAAD///+AgP+AgP9mZv+AgNWAgP9tbf9gYP+AgP9xcf9mZv+AZuaAgP9dXf90dOhiYv92dv9mZu5mZv93d+53d/9paf94afCAcfFrXvJra/9mZvJzZvJzc/JoaP96b/Rqav91aupsYvV2bOt2bPVxaPZ7cfZqavZyau1waPd4aO9xafBxafh4afB1bfh4avFuZ/F2afJzZvJzZ/N0aPN0bvN3bPR0ae5yZ/R3be93bfR1au9zafBxbPVzavV0a/F0a/ZyafFwaPKZm3nTAAAAQ3RSTlMAAQIEBQYGBwgICQoKCgsLDQ0PDw8PERESExMUFBQWFxgYGhoaGxsdHSAgIiIiIyQlJygqLCwtLi8vLzAzNDU3Nzg7h9vbHgAAA9RJREFUeNrt3ftS2kAUx/Fc1gSyWsErtuJdRDQiiteolb7/QzUoTm07k4AzObuu3/MCez45yWbzT36eZ6b8erO1e1B97baadd+zocJWmg0HaXe/+uqmg2GWtkLT5Lle1m9LdhG2+1lvzuiUO1knEF81yFc1N+35m15kZOGodz1vyLx+v2Lseq/erxtZd/NuweCTtfiwaWLOD5FnsqI7+VnP3y8afnEs3Es/1+H1qvETwuq18B7e6VlwLup1ZM8kWWQBOsrmHL7GVtxvYRZYgQ4ywae61ffsqH5Lbq20bQm6ncp9P2ehJegwE/u+rl95ttSwLrVSc2ANetAU28dSa9Cp2E623bUG3d2VWmn/wBq0XCugQYMGLdVKoOJaoiuok1NdXSW1WAUfRPtRUllflaJf5ZE/O9pXVbZUPTov5c+IDqvtRwStdTgLutoxy6GnGfYb2o+1I2gd+1OiqzfLocvVE7TSDqG1mgodaqfQZbvZC9rXjqG1X45WzqFVKVpk0LLo4lGP0ZGD6KgMnTiITkrQgXYQrYNitHISrYrRsZPouBhdcxJdK0YnTqKTYrR2Eq1BgwYNGjRo0KBBgwYNGjRo0KBBgwYNGjRo0KBBgwYNGjRo0KBBgwYNGjRo0KBBgwYNGjRo0KBBgwYNGjRo0KBBgwYNGjRo0KBBgwYNGjRoh9DH59ag86ACoSYOL61B55EUQk1s3VqDzsNHhJpYe7QGncfMSHUxaliCHgcKSXVxeWQJehwdJdXF4dAS9DgkTKqLxuibFeiXODixNi7OrEC/BP+JtbE0WrYA/RrxKNfH2YUF6NegSbk+Gk87xtErN6EsWm88fzeMXpwE9EruLns/l42io4dJFLPo2/Po1w+D6IW7t9Bt2SPx3vOOMfS7eHVZtN54ulg2go56138Ct4XRunE2Ovsmjg46WeddUoUWr6WL0fCoIYgO2/2s91fstDZQjcPL0ePt5flpdXUwqW46uMrS1j95JNpQrW0dHp9UV/uT2m416/8HVGg3qzhpBjRo0KBBgwYNGjRo0KBBgwYNGjRo0KBBgwYNGjRo0KBBgwYNGjRo0KBBgwYNGjRo0KBBgwYNGjRo0KBBgwYNGjRo0KBBgwYNGjRo0KBBgwYNGjRo0KC/FDpx0pwUo2tOomvF6NhJdFyMVk6iVTE6cBIdeF9vJyvZx/I/AzuIjsrQvoNovwzt4FamSs0Ojrp80PmvoB0zh940pb7azf1yg7t0LIt978uppzbnalfucDW92ZndLPRmKweGPduYJ+zoM5/Dk+gD5NdvLhXXPp88qcUqmEH5G5JZRs6cuxwIAAAAAElFTkSuQmCC");
}
[dir=ltr] .auth-wrapper.auth-v1 .auth-inner:before {
  left: -46px;
}
[dir=rtl] .auth-wrapper.auth-v1 .auth-inner:before {
  right: -46px;
}
@media (max-width: 575.98px) {
.auth-wrapper.auth-v1 .auth-inner:before {
    display: none;
}
}
.auth-wrapper.auth-v1 .auth-inner:after {
  width: 272px;
  height: 272px;
  content: " ";
  position: absolute;
  bottom: -55px;
  z-index: -1;
}
[dir] .auth-wrapper.auth-v1 .auth-inner:after {
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARAAAAEQCAMAAABP1NsnAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAABEKADAAQAAAABAAABEAAAAAAQWxS2AAAAwFBMVEUAAAD///+AgICAgP9VVaqqVf+qqv+AgL+AgP9mZsxmZv+ZZv+AgNWAgP9tbdttbf+Sbf+AYN+AgN+AgP9xceNmZv+AZuaAZv90dOh0dP9qav+AauqAav+AgP92dv9tbf+Abe2Abf93Zu53d+6AcO94afCAcfF5a+R5a/JzZuaAZvKAc/J5bed5bfOAaPN6b/R1auqAavR6ZvV6cPV2bOuAbPV7aPZ2be2AbfZ7au17avZ3Zu53b+57a+97a/d4aO9J6CoeAAAAQHRSTlMAAQICAwMDBAQFBQUGBgcHBwgICAkKCgoLCwwMDAwNDg4ODw8QERITExQUFBUVFhcYGBkZGhobHBwdHR4eHx8gJ5uMWwAAA/FJREFUeNrt2G1XEkEYxvHZNk2xHGzdbKFl0cTwgdSkCKzu7/+t4pw6sAjtjIueE/f8r3fMO35nZnbuy5gVGcvfzJe0rnTfGI+MggGJRUZnbpPIhJKt88nU53JnFULvyISY6KAv8vPj0vr2rYwiE2Z2B9J+uNYcyyQxwWZvaeGH3G4bMjsvI/kcwTC/V+7kLoahlITzQojP3ZFgsJCh7IJQzpX0QFj4uMiY18eDMZ9bZCF9OQahnK6cm/Y7js0sh/LF3Auv1PlQd3MxbdXYIQspV44EEEAAAWTNDAYYkKdJbNMsLzYueZbaZ2iM46RVbHBaiZ9Js+nHEdli42N9XuSen5hGp1CQTuOJQDRsD99N4gMSpYWapNH6IJo83CIeILZQFesEaber79NCWRoukOpNEnW0gXQqD81w6ACxhbrYde7VuFCYeA2QRCNIsgZISyNIqz6IyhPjOjNVIFYniK3dmKU6QdLaJUimEySrDZLrBMlrgxRKU7sxCw/EMe0CAggggADySJCqxixIkKpNEh6IozELD8RxjQACCCCAAPJIkKrGLEgQXqqAAEJjxrQLCCCAAEJjRmNGY8a0CwgggABCYwYIfQgggNCYMe0CAggggNCY0ZjRmDHtAgIIIIAAQmNGHwIIIDRmTLuAAAIIIDRmNGY0Zky7gAACCCCA0JjRhwACCI0Z0y4ggAACCI0ZjRmNGdMuIIAAAgggNGb0IYAAQmPGtAsIIIAAQmNGY0ZjxrQLCCCAAAIIjRl9CCCA0Jgx7QICCCCA0JjRmNGYMe0CAggggABCY0YfAgggNGZMu4AAAgggNGY0ZjRmTLuAAAIIIIDQmNGHAAIIjRnTLiCAAAIIjRmNGY0ZIEy7gAACCCA0ZvQhgABCY8a0CwgggABCY0ZjBgiNGdMuIIAAAgiN2f/Sh+Q6PfLaIJlOkKw2SKoTJK3dmFmdILb2tBvrBIlrg5iWRo+WqQ+SaARJ1gCJAzsxThCN16p1vNurGjNjoo42j07kAHFskoY2kEbl33U0ZgoPjXW+Rl0gkarnahqtDaJKxMPDDWIiNafGenh4gExvVhXfmk7Da6L1AVGxSby2h6MxK79Zk42ea1pJbJ48sU2zDezQ8iy1z6BBwoyjMQsvXp8YQAAhgADilRfyy+wf8WqZZUfGZihvgZiB3FybC+kCUU5XLkAo50C+gbBQdUzkAIVyejIAYfFTI1solHP2HgNCnHn5AYNy4jvpoVB6fVzL91cwzLJ9Lfd7S0jhehxO5H5/yePr1W6gHonI7fJ5ORSR/n6Q2yQanq763zuXU5LJZRKiyD/W9/pjkdPZz0/yJ8fqVyry+qQZDMjJKoDfy8bRVhHhQTwAAAAASUVORK5CYII=");
}
[dir=ltr] .auth-wrapper.auth-v1 .auth-inner:after {
  right: -75px;
}
[dir=rtl] .auth-wrapper.auth-v1 .auth-inner:after {
  left: -75px;
}
@media (max-width: 575.98px) {
.auth-wrapper.auth-v1 .auth-inner:after {
    display: none;
}
}
.auth-wrapper.auth-v2 {
  align-items: flex-start;
}
.auth-wrapper.auth-v2 .auth-inner {
  height: 100vh;
  overflow-y: auto;
  height: calc(var(--vh, 1vh) * 100);
}
.auth-wrapper.auth-v2 .brand-logo {
  position: absolute;
  top: 2rem;
  z-index: 1;
}
[dir] .auth-wrapper.auth-v2 .brand-logo {
  margin: 0;
}
[dir=ltr] .auth-wrapper.auth-v2 .brand-logo {
  left: 2rem;
}
[dir=rtl] .auth-wrapper.auth-v2 .brand-logo {
  right: 2rem;
}
.auth-wrapper.auth-v1 .auth-inner {
  max-width: 400px;
}
.auth-wrapper .brand-logo {
  display: flex;
  justify-content: center;
}
[dir] .auth-wrapper .brand-logo {
  margin: 1rem 0 2rem 0;
}
.auth-wrapper .brand-logo .brand-text {
  font-weight: 600;
}
[dir] .auth-wrapper .auth-footer-btn .btn {
  padding: 0.6rem !important;
}
[dir=ltr] .auth-wrapper .auth-footer-btn .btn:not(:last-child) {
  margin-right: 1rem;
}
[dir=rtl] .auth-wrapper .auth-footer-btn .btn:not(:last-child) {
  margin-left: 1rem;
}
@media (min-width: 1200px) {
.auth-wrapper.auth-v2 .auth-card {
    width: 400px;
}
}
[dir] .auth-wrapper .auth-bg {
  background-color: #fff;
}
[dir] .dark-layout .auth-wrapper .auth-bg {
  background-color: #283046;
}
html[dir=rtl] svg.feather {
  transform: rotate(180deg);
}

/* Set specific width and height for the reCAPTCHA container */
.google-btn {
  justify-content: center;
  width: 100%;
}
.google-btn p {
  color: #000000;
  font-weight: 400;
}
label {
  font-weight: bold !important;
  color: rgba(0, 0, 0, 0.5);
  font-size: 1rem;
  font-weight: 500 !important;
}
[dir] label {
  margin-bottom: 6px;
}
</style>
